/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-09 09:32:25
 * @modify date 2021-09-09 09:32:25
 * @desc [公共无状态数据]
 */
import dayjs from 'dayjs';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers';
@BindAll()
export class CurrencyController {
  /**
   * @desc SN 上报动态时间
   */
  get isSN() {
    const diff = dayjs().diff('2022-09-30', 'day');
    return diff < 1;
  }
  /** 图片验证码 */
  getImgCode() {
    return AjaxBasics.request<{ imgCode: string; sessionCode: string }>(
      EnumAPI.bffsvr_imgCode,
    );
  }
  /** 发送短信验证码 */
  sendCode(queryParams: { imgCode; imgSession; mobilePhone; sendType }) {
    return AjaxBasics.request({
      ...EnumAPI.bffsvr_SendCode,
      body: queryParams,
      queryParams,
      headers: lodash.pick(queryParams, 'imgSession'),
    });
  }
  /** 账号中心图片验证码 */
  getImgCodeForAccount(body) {
    return AjaxBasics.request<{ imgCode: string; sessionCode: string }>({
      ...EnumAPI.accountsvr_imgCode,
      body,
    });
  }
  /** 账号中心lenovoid图片验证码 */
  getImgCodeForLenovoid(lenovoidKey) {
    return AjaxBasics.request({
      ...EnumAPI.accountsvr_imgCode_lid,
      body: { t: lenovoidKey },
    });
  }
  /** 账号中心发送短信验证码 */
  sendCodeForAccount(queryParams: {
    endpoint;
    receiverType;
    scene;
    imgCode;
    imgSession;
    t;
  }) {
    return AjaxBasics.request({
      ...EnumAPI.accountsvr_SendCode,
      // body: lodash.pick(queryParams, ['endpoint', 'receiverType', 'scene', 'imgCode', 't']),
      body: lodash.pickBy(
        lodash.pick(queryParams, [
          'endpoint',
          'receiverType',
          'scene',
          'imgCode',
          't',
        ]),
        lodash.identity,
      ),
      // queryParams,
      headers: { 'img-session': lodash.get(queryParams, 'imgSession') },
    });
  }
  /** 上传图片 */
  uploadimg(file) {
    const body = new FormData();
    body.append('file', file);
    return AjaxBasics.request({ ...EnumAPI.content_upload_img, body });
  }
  /**
   * 获取 省
   * @returns
   */
  getProvinces() {
    return AjaxBasics.requestEnum(EnumAPI.usersvr_provinces, {
      labelKey: 'name',
      valueKey: 'citycode',
    });
  }
  /**
   * 获取 市
   * @returns
   */
  getCities(citycode) {
    return AjaxBasics.requestEnum(
      { ...EnumAPI.usersvr_cities, body: { citycode } },
      { labelKey: 'name', valueKey: 'citycode' },
    );
  }
  /**
   * 获取 区
   * @returns
   */
  getDistrict(citycode) {
    return AjaxBasics.requestEnum(
      { ...EnumAPI.usersvr_district, body: { citycode } },
      { labelKey: 'name', valueKey: 'citycode' },
    );
  }
  /**
   * 获取 PC 指引状态
   * @returns
   */
  async getPcGuide() {
    const res = await AjaxBasics.request(EnumAPI.content_guide_check);
    return res;
  }
  /**
   * 获取 PC 指引手册链接
   * @returns
   */
  async getPcGuidePdf() {
    const res = await AjaxBasics.request(EnumAPI.content_guide_pdf);
    return res;
  }
  /**
   * 获取 指引状态
   * @returns
   */
  async getGuide() {
    const res = await AjaxBasics.request(EnumAPI.bffsvr_guide_get);
    const status = lodash.get(res, 'status', false);
    if (status) {
      this.setGuide(0);
    }
    return status;
  }
  /**
   * 设置 指引状态
   * @returns
   */
  setGuide(status: 0 | 1) {
    return AjaxBasics.request({
      ...EnumAPI.bffsvr_guide_set,
      body: { status },
    });
  }
  /**
   * 这里是单独给 个人中心-收货地址用的 centerArea
   * @param wheres
   * @param tableName
   * @returns
   */
  getAddress(wheres, tableName: 'province' | 'city' | 'county') {
    const options = lodash.get(
      {
        province: { labelKey: 'province_name', valueKey: 'province_id' },
        city: { labelKey: 'city_name', valueKey: 'city_name' },
        county: { labelKey: 'county_name', valueKey: 'county_name' },
      },
      tableName,
    );
    wheres = lodash.get(
      {
        province: { smb_province_id: wheres },
        city: { province_id: wheres },
        county: { city_name: wheres },
      },
      tableName,
    );
    return AjaxBasics.requestEnum(
      { ...EnumAPI.usersvr_address, body: { tableName, wheres: wheres } },
      options,
    );
  }

  /** 获取k码的list */
  async getResellerByTax() {
    const res = await AjaxBasics.request<Array<string>>(
      EnumAPI.bffsvr_getResellerByTax,
    );
    return lodash.map(res, (item) => {
      return {
        label: item,
        value: item,
      };
    });
  }
  /**
   * 获取授权牌信息
   * @return {*}
   * @memberof CurrencyController
   */
  getLicense() {
    return AjaxBasics.request<any>(EnumAPI.content_license_user_token);
  }
  /**
   * 报错授权牌信息
   * @param {*} body
   * @return {*}
   * @memberof CurrencyController
   */
  saveLicense(body) {
    return AjaxBasics.request({ ...EnumAPI.content_license_record_save, body });
  }

  codeTable = [];
  subtypeTypeList = [];
  rolesList = [];

  // 获取码表
  getFieldName(field, value) {
    if (field == 'BusinessUnit') {
      // REL和ISG合并，文案展示
      let labelName =
        lodash.find(lodash.filter(this.codeTable, ['dicType', field]), [
          'itemId',
          value,
        ])?.itemName || '';
      let checkCondition =
        (labelName == 'REL' || labelName == 'ISG') && labelName != '';
      return checkCondition ? '政企' : labelName;
    }
    return (
      lodash.find(lodash.filter(this.codeTable, ['dicType', field]), [
        'itemId',
        value,
      ])?.itemName || ''
    );
  }

  // 渠道类型子类型
  getReseller(value) {
    if (lodash.isEmpty(value)) {
      return '';
    }

    let arr = lodash.map(value, this.resellerTypeJoint);
    return lodash.toString(arr).replace(/\,/g, '；');
  }
  resellerTypeJoint(item) {
    let subList =
      lodash.find(this.subtypeTypeList, ['resellerTypeId', item.typeId])
        ?.subtypeList || [];

    const resellerName =
      lodash.find(this.subtypeTypeList, ['resellerTypeId', item.typeId])
        ?.resellerTypeName || '';

    const resellerSubName =
      lodash.find(subList, ['resellerSubtypeId', item.subtypeId])
        ?.resellerSubtypeName || '';
    return `${resellerName} ${resellerSubName ? '- ' + resellerSubName : ''}`;
  }

  // 角色
  getRoleName(value) {
    if (!value) return;
    const splitRole = value.split(',');
    let arr = lodash.map(splitRole, (item) => {
      return (
        lodash.find(this.rolesList, ['id', Number(item)])?.roleName || '--'
      );
    });
    return lodash.toString(arr);
  }

  async getTableCode() {
    this.codeTable = await AjaxBasics.request({
      ...EnumAPI.codetable_batch_type,
      body: [
        'BusinessUnit',
        'IdentityType',
        'SignStatus',
        'ApprovalStatus',
        'PartnerTier',
      ],
    });
  }

  // 渠道子类型
  async getSubtypeType() {
    try {
      this.subtypeTypeList = await AjaxBasics.request(
        EnumAPI.bpresellertypeinfos_get,
      );
    } catch (error) {}
  }

  // 角色
  async getRoleList() {
    try {
      this.rolesList = await AjaxBasics.request(EnumAPI.partner_get_role);
    } catch (error) {}
  }

  // 合作业务
  async getBusinessType() {
    // const res = await AjaxBasics.requestEnum(
    //   {
    //     ...EnumAPI.codetable_batch_type,
    //     body: ['BusinessUnit'],
    //   },
    //   {
    //     responseKey: 'data',
    //     labelKey: 'itemName',
    //     valueKey: 'itemId',
    //   },
    // );
    return [
      {
        label: 'ISG',
        value: 'BU006',
      },
    ];
    // return lodash.filter(
    //   res,
    //   (item) =>
    //     lodash.get(item, 'original.parentId') !== '-1' &&
    //     lodash.includes(['SMB', 'CON', 'REL', 'ISG'], item.label),
    // );
  }
}
